var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-video"},[(_vm.unitData.video_url)?_c('video',{attrs:{"src":_vm.unitData.video_url}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }